import _ from 'lodash';
import moment from 'moment-timezone';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Tag = styled.span`
  text-transform: none;
  border-radius: 10px;
  background-color: ${props => props.theme.primaryColor};
  font: ${props => props.theme.fontWeightHeavy} 10px/10px ${props => props.theme.fontFamilyBody};
  color: white;
  padding: 2px 10px;
`;

const formatDate = d => moment(d).tz('Australia/Sydney').format('DD MMM, YYYY');

const tagName = d => {
  const lowerText = _.toLower(d);
  if (_.startsWith(lowerText, 'trending on livewire - ')) {
    return 'TOL';
  }
  if (_.startsWith(lowerText, 'livewire weekend edition - ')) {
    return 'LWE';
  }
  return null;
};

export default function TolTag({ name, sentDate }) {
  const tag = tagName(name);

  if (!tag) {
    return null;
  }

  return (
    <Tag>{`${tag} - ${formatDate(sentDate)}`}</Tag>
  );
}

TolTag.propTypes = {
  name: PropTypes.string.isRequired,
  sentDate: PropTypes.string.isRequired,
};
